import { Text, TextInputNew } from '@jfs/ui-new'

const RefundInvoiceView = ({ data, onInvoiceChange, isSodexo, isRowChecked }: any) => {
  const onChangeText = (text: string) => {
    if (onInvoiceChange) {
      onInvoiceChange(text)
    }
  }

  if (!isSodexo) {
    return <Text title={'NA'} fontSize={12} color={'BLACK_21'} fontFamily={'jiotype-medium'} />
  }
  return (
    <TextInputNew
      value={data}
      onChangeText={onChangeText}
      type={'body12'}
      touched
      editable={isSodexo && isRowChecked}
      testID="refundInvoiceInput"
      showBottomLine={false}
      textAlign={'center'}
      borderRadius={4}
      padding={4}
      focusBorderColor={'DISABLED_GREY'}
      borderColor={'DISABLED_GREY'}
    />
  )
}

export { RefundInvoiceView }
